import { CART_MODULE } from "@/api_framework/api_config";
import { IAddAddressBody } from "@/api_framework/api_modals/Users";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useCustomerDetailsAPI } from "../customer_profile/useCustomerDetailsAPI";
import { IHDAddAddressResponse } from "@/api_framework/api_modals/Cart";

AxiosCurlirize(axios, () => {});
export type AddAddressAPIOptions = {
  refetchCustomerDetails?: boolean;
};

// returns new created addressID
export const useHDAddAddressAPI = () => {
  const configuration = useConfiguration();
  const [newAddressId, setNewAddressId] = useState<string | null>(null);
  const fetchCustomerDetails = useCustomerDetailsAPI();
  const { sendCurl } = useCurlLogger();
  const { toastNotification, captureError } = useAPIUtils();
  const execute = useCallback(
    async (
      formData: IAddAddressBody,
      options?: AddAddressAPIOptions,
    ): Promise<IHDAddAddressResponse["data"] | null> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
        const requestHeaders = new Headers();
        requestHeaders.append("Authorization", `${accessToken}`);
        const response = await axios
          .post(CART_MODULE?.HD_ADD_ADDRESS?.baseURL ?? "", formData, {
            headers: { Authorization: requestHeaders.get("Authorization") },
          })
          .then((res: AxiosResponse<IHDAddAddressResponse>) => {
            if (res.data.status === true) {
              toastNotification(`Address has been added.`);
              // setNewAddressId(res.data?.data?.generated_address_id);
              if (options) {
                if (options?.refetchCustomerDetails) {
                  fetchCustomerDetails(formData?.user_id);
                }
              }
              return res.data?.data;
            } else {
              setNewAddressId(null);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            setNewAddressId(null);
            sendCurl(e.config["curlCommand"]);

            // if (e.status === 400 || e.code === "ERR_BAD_REQUEST") {
            //   toast.error(`${formData?.address_1} could not be created API creation error ${e.message}`);
            // }
            return null;
          });
        return response;
      } catch (e: any) {
        captureError(e);
        toast.error("Server Error");
        return null;
      }
      return null;
    },
    [],
  );
  return { newAddressId, execute };
};
